import { render, staticRenderFns } from "./NewTabReport.vue?vue&type=template&id=648d6e4a"
import script from "./NewTabReport.vue?vue&type=script&lang=js"
export * from "./NewTabReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports